module.exports = __webpack_public_path__ + "img/6-img-copy@2x.5e33005d.jpg";